import { render, staticRenderFns } from "./RecentArticles.vue?vue&type=template&id=1b30fcfe&scoped=true&"
import script from "./RecentArticles.vue?vue&type=script&lang=js&"
export * from "./RecentArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b30fcfe",
  null
  
)

export default component.exports